import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { DownloadFileService } from '../../../services/Download-File/download-file.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-download-view',
  templateUrl: './download-view.component.html',
  styleUrls: ['./download-view.component.css'],
})
export class DownloadViewComponent implements OnInit {
  isDownloadReady: any;
  download: any;
  innerWidth: any;
  innerHeight: any;
  value: any;
  parcel: any;
  loaded: any;
  xmin: any;
  xmax: any;
  ymin: any;
  ymax: any;
  enabled_overlay: any[] = [];
  overlayLayer: any;
  multipleParcel = false;
  zoom: any;
  buffers = '';
  buffersInner = '';
  json: any;
  shareUrl: any;
  showAnnotations = '';
  fileNameData: any;
  selectedPoint = '';
  embedEode = false;
  tcpdEmbed = false;
  basicMode = false;
  dataPanelHide = false;
  mapName = 'google-hybrid';
  mapId: any;
  requireCheckbox = false;
  parcelLabel = '';
  shereLinkData: any;
  userAccessLevel: any;
  title: any;
  titleFile: any;
  fileName: any;
  DownloadFileName: any;
  isPdf = true;
  pdfFile: any;
  isEmbed = false;
  checkboxTemplate = '';
  RequireCheckBox = false;
  defaultModal = false;
  template = '';
  minZoom = '0';
  isGeolock = false;
  html: any;
  eventName: any;
  logEvent: any;
  state: any;
  panelHidden: any;

  constructor(
    public sideNavService: SideNavService,
    public mapService: MapServiceService,
    public downloadFileService: DownloadFileService,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {
    this.isDownloadReady = false;
    this.loaded = true;
  }

  ngOnInit(): void {
    this.mapService.getLayersId();
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.state = this.sideNavService.downloadViewState;
    this.fileName = this.sideNavService.fileName;
    this.panelHidden = this.sideNavService.hidePanel;
    // console.log(this.fileName,"first")
    if (
      !this.mapService.accessMapApi.map_data.map_data.tool_desc['data-view']
    ) {
      this.html = '';
    } else {
      this.html =
        this.mapService.accessMapApi.map_data.map_data.tool_desc['data-view'];
    }
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    if (!this.mapService.baseLayerName) {
      this.mapService.baseLayerName = this.mapName;
    } else {
      this.mapService.baseLayerName;
    }
    this.zoom =
      this.mapService.mapLayer.getView().getZoom() -
      this.mapService.mapsData.minzoom;
    this.route.queryParamMap.subscribe((params) => {
      setTimeout(() => {
        this.downloadFileService.shareUrlId = params.get('share');
      }, 1000);
    });
    const originUrl = environment.originUrl;
    const href: any = this.router.url.split('?').shift();
    this.shareUrl = originUrl.concat(href);
    this.userAccessLevel = this.mapService.mapAccessLevel;
    this.dataPanelHide = false;

    this.isEmbed = false;
    this.overlayLayer = this.mapService.getLayersId().toString();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }
  fileTitle(e: any): void {
    this.title = e.target.value;
  }

  onSelect(e: any): void {
    this.dataPanelHide = e.target.checked;
    this.sideNavService.hidePanel = e.target.checked;
    this.panelHidden = this.sideNavService.hidePanel;
  }

  onItemChange(e: any) {
    this.sideNavService.fileName = e.target.value;

    if (e.target.value === 'pdf') {
      this.sideNavService.downloadViewState.pdf = true;
      this.sideNavService.downloadViewState.png = false;
    } else {
      this.sideNavService.downloadViewState.pdf = false;
      this.sideNavService.downloadViewState.png = true;
    }
    this.state = this.sideNavService.downloadViewState;
    this.fileName = this.sideNavService.fileName;
  }

  downloaded(): void {
    // console.log("downloaded")
  }
  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   */
  // downLoadFile() {
  //   const blob = new Blob([this.DownloadFileName], { type: 'application/pdf' });
  //   const url = window.URL.createObjectURL(blob);
  //   const pwa = window.open(url);
  //   if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
  //     alert('Please disable your Pop-up blocker and try again.');
  //   }
  // }
  downLoadFile() {
    this.download = document.getElementById('download-map');
    this.download.href = `${this.sideNavService.downloadFileUrl}/media/downloaded_reports/${this.fileNameData}`;
    this.download.target = '_blank';
    this.download.style.display = 'inline-block';
  }

  createFile(): void {
    this.zoom =
      this.mapService.mapLayer.getView().getZoom() -
      this.mapService.mapsData.minzoom;
    const bounds = this.mapService.mapLayer
      .getView()
      .calculateExtent(this.mapService.mapLayer.getSize());
    for (let i = 0; i < bounds.length; i++) {
      if (i == 0) {
        this.xmin = bounds[i];
      } else if (i == 1) {
        this.xmax = bounds[i];
      } else if (i == 2) {
        this.ymin = bounds[i];
      } else if (i == 3) {
        this.ymax = bounds[i];
      }
    }
    if (!this.overlayLayer) {
      this.overlayLayer = '';
    }
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = '';
    }
    if (!this.mapService.pointGeometry) {
      this.mapService.pointGeometry = '';
    }
    if (!this.mapService.featureLayerId) {
      this.mapService.featureLayerId = '0';
    }
    if (!this.title) {
      this.title = '';
    }
    if (this.fileName === 'pdf') {
      this.isPdf = true;
      this.pdfFile = 'PDF';
    } else {
      this.pdfFile = 'PNG';
      this.isPdf = false;
    }
    if (!this.fileName) {
      this.fileName = '';
    }
    if (this.mapService.multiParcelId.length > 1 && this.mapService.ctrlPush) {
      this.mapService.multiParcel = true;
    } else {
      this.mapService.multiParcel = false;
    }
    if (!this.mapService.parcel) {
      this.mapService.parcel = '';
    }
    if (!this.downloadFileService.shareUrlId) {
      this.downloadFileService.shareUrlId = '';
    }
    if (!this.mapService.innerBuffer) {
      this.mapService.innerBuffer = '';
    }
    if (this.sideNavService.checkLabel) {
      this.parcelLabel = this.mapService.parcel;
    }
    this.mapService.innerBuffer = this.mapService.innerBuffer.filter((value: any) => value !== null && typeof value !== "undefined");
    const body = {
      xmin_bound: this.xmin.toString(),
      xmax_bound: this.xmax.toString(),
      ymin_bound: this.ymin.toString(),
      ymax_bound: this.ymax.toString(),
      width: this.innerWidth,
      height: this.innerHeight,
      zoom: this.zoom.toString(),
      parcel: this.mapService.parcel,
      overlay: this.overlayLayer,
      base_layer: this.mapService.shareCurrentMap,
      feature_layer: this.mapService.featureLayerId,
      point: this.mapService.pointGeometry,
      wkt: this.mapService.polygonGeometry,
      multiple_parcel: this.mapService.multiParcel,
      expiry_time: '0',
      expire: false,
      buffers: this.mapService.bufferPolygonGeometry,
      buffers_inner: this.mapService.innerBuffer,
      show_annotations: this.mapService.annotationShare.toString() || '',
      selected_point: this.mapService.preSelectedAnnotation || '',
      basic_mode: this.basicMode,
      tcpd_embed: this.tcpdEmbed,
      require_checkbox: this.requireCheckbox,
      checkbox_template: this.checkboxTemplate,
      chosen_privilege_level: +this.userAccessLevel,
      show_legend: false,
      default_modal: this.defaultModal,
      template: this.template,
      parcel_label: this.parcelLabel,
      data_panel_hide: this.dataPanelHide,
      share_url: this.shareUrl,
      is_embed: this.isEmbed,
      print_title: this.title,
      is_pdf: this.isPdf,
      minzoom: +this.minZoom,
      is_geolock: (this.isGeolock = false),
    };
    this.eventName = `${'DownloadView'}:${this.pdfFile}:${'Create'}`;
    this.json = {
      download_hide_data_panel: `${this.sideNavService.hidePanel} `,
      download_map_title: `${this.title} `,
    };
    this.json = JSON.stringify(this.json);
    this.activityLoging();

    this.spinner.show();
    this.downloadFileService
      .downloadView(this.mapId, this.downloadFileService.shareUrlId, body)
      .subscribe((res: any) => {
        setTimeout(() => {
          this.isDownloadReady = true;
          this.fileNameData = res.file_name;
          this.DownloadFileName = `${this.sideNavService.downloadFileUrl}/media/downloaded_reports/${res.file_name}`;
          this.spinner.hide();
        }, 1000);
      });
  }

  activityLoging() {
    if (!this.mapService.pointGeometry) {
      this.mapService.pointGeometry = '';
    }
    if (!this.mapService.polygonGeometry) {
      this.mapService.polygonGeometry = '';
    }
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: this.eventName,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          event_information: this.json,
          wkt: this.mapService.pointGeometry,
          point: this.mapService.polygonGeometry,
          multiple_parcel: this.mapService.multiParcel.toString(),
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }

  closeLeft() {
    this.mapService.closePanel = true;
    this.mapService.setClosePanel(true);
  }
}
